import React, { useState } from 'react';
import { Button, Typography, makeStyles } from '@ellucian/react-design-system/core';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { fontSizeSmall, spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { routes } from '../Helpers/Configuration';
import { useApi } from '../ApiContext';
import { useSnackbar } from '../SnackbarContext/SnackbarContext';
import LoadingButton from '../Common/LoadingButton';


const useStyles = makeStyles((theme) => ({
    root: {
        padding: `${spacing40} 0`,
        width: '100%',
    },
    container: {
        margin: '4rem auto 4rem auto',
        maxWidth: '800px',
        display: 'flex',
        justifyContent: 'center',
    },
    mainGrid: {
        alignItems: 'center',
        width: '70%'
    },
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'justify',
        marginBottom: spacing40
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row-reverse',
        marginTop: spacing40
    },
    button: {
        marginLeft: spacing40
    },
    [theme.breakpoints.down('sm')]: {
        codeContainer: {
            width: '100%'
        },
        mainGrid: {
            width: '90%',
        },
        title: {
            fontSize: fontSizeSmall
        },
        container: {
            margin: '0'
        }
    },
}));
const LostRecoveryCode = () => {
    const classes = useStyles();
    const history = useHistory();
    const api = useApi();
    const snackbar = useSnackbar();
    const [isDisabled, setIsDisabled] = useState(false);
    const userEmail = window.PRELOADED_STATE?.user?.email || '';
    const model = {
        email: userEmail,
    };
    const handleSubmit = async () => {
        try {
            setIsDisabled(true);
            const result = await api.mfaAuth.mfaReset();
            const { mfaEnabled = false } = result;
            if (!mfaEnabled) {
                window.location.href = routes.home;
                return;
            }
            await api.inquiries.retrieve(model);
            history.replace(routes.totpResetConfirm);
        } catch (e) {
            let msg = '';
            const errorData = e.response.data;
            if (errorData.msg) {
                msg = e.response.data.msg;
            }
            snackbar.error(msg);
            setIsDisabled(false);
        }
    };
    const handleBack = (e) => {
        e.preventDefault();
        history.replace(routes.totpReset);
    };

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div  className={classes.mainGrid}>
                    <div className={classes.wrapper}>
                        <Typography>
                            <FormattedMessage id="applicationRetrievalLostRecoveryCodeInstructions" />
                        </Typography>
                    </div>
                    <div className={classes.buttonContainer}>
                        <LoadingButton
                            isLoading={isDisabled}
                            color="primary"
                            className={classes.button}
                            onClick={handleSubmit}
                        >
                            <FormattedMessage id="confirm" />
                        </LoadingButton>
                        <Button color="secondary" className={classes.button} onClick={(e)=>handleBack(e)} disabled={isDisabled}>
                            <FormattedMessage id="back" />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LostRecoveryCode;